import request from "@/utils/request";

// 管理员登录
export function login(data: { username: string; password: string }) {
  return request.post("/auth/login", data);
}

// 获取当前用户信息
export function getProfile() {
  return request.get("/auth/profile");
}

// 修改密码
export function updatePassword(data: { oldPwd: string; newPwd: string }) {
  return request.post("/auth/password", data);
}

// 登出
export function logout() {
  return request.post("/auth/logout");
}
